// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_1uTh9PZ","button":"_3uVNHrl"};